import { render, staticRenderFns } from "./GroupNavbar.vue?vue&type=template&id=79f845bc&"
import script from "./GroupNavbar.vue?vue&type=script&lang=js&"
export * from "./GroupNavbar.vue?vue&type=script&lang=js&"
import style0 from "./GroupNavbar.vue?vue&type=style&index=0&id=79f845bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports